import React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ errorMessage =  false }) => {
  if (!errorMessage) {
    return null;
  }

  return (
    <div className="auth__error-message">
      {errorMessage.replace(/\.$/, '')}
    </div>
  );
};

ErrorMessage.propTypes = {
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/Authentication/components/ErrorMessage.js